import { render, staticRenderFns } from "./DonutBooking.vue?vue&type=template&id=3d24c344&scoped=true&"
import script from "./DonutBooking.vue?vue&type=script&lang=js&"
export * from "./DonutBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d24c344",
  null
  
)

export default component.exports